/**
 * Legacy route `/membresia-vip` → redirige a la landing canónica.
 * Mantiene query string (?country=, ?email=, etc.) para links viejos y fallbacks.
 */

import { Navigate, useLocation } from "react-router-dom";
import { PREMIUM_INVITE_LANDING_PATH } from "@/lib/premiumVipCheckoutDestination";

export default function MembresiaPremiumVip() {
  const { search } = useLocation();
  return <Navigate to={`${PREMIUM_INVITE_LANDING_PATH}${search}`} replace />;
}